import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {SelectItem} from 'primeng/api';
import {environment} from 'projects/app-ui/src/environments/environment';
import {SendInBlueApiService} from '../../services/send-in-blue-api.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorSendInBlueService} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-sib-select-smtp-templates',
    templateUrl: './sib-select-smtp-templates.component.html',
    styleUrls: ['./sib-select-smtp-templates.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SibSmtpTemplatesComponent
        }
    ],
    standalone: false
})
export class SibSmtpTemplatesComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
    devMode = !environment.production;
    template: SelectItem;
    templates: SelectItem[] = [];
    @Input() inputId = '';
    @Input() fluid = false;
    disabled = false;
    loading = false;
    loadError = false;
    private request?: Subscription;
    private readonly refreshOnFocus = () => this.sync();
    tempTemplates: string[] = [];

    // @Input() formControlName: string;
    @Input() tenant: string;
    @Input() value: number;
    @Output() valueChange = new EventEmitter<number>();

    @Input() readonly = false;

    touched = false;

    constructor(
        protected sendInBlueApiService: SendInBlueApiService,
        protected configuratorSendInBlueService: ConfiguratorSendInBlueService
    ) {
    }

    ngOnInit() {
        this.load();
    }

    onChange = (value) => { /**/ };
    onTouched = () => { /**/ };
    writeValue(value: any): void {
        this.value = value;
        this.setValue();
    }
    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tenant && !changes.tenant.firstChange) { this.load(); }
        if (changes.value) { this.setValue(); }
    }

    private setValue() {
        this.template = this.templates.find(t => t.value === this.value);
    }

    change(event = null) {
        if (!this.readonly && !this.disabled && this.template) {
            this.value = this.template.value;
            this.valueChange.emit(Number(this.template.value));
            this.onChange(this.value);
            this.markAsTouched();
        }
    }

    sync() {
        this.load();
    }

    edit() {
        if (this.template && this.template.value) {
            this.sendInBlueApiService.openSmtpTemplate(this.template.value);
        }
    }

    newTemplate() {
        window.removeEventListener('focus', this.refreshOnFocus);
        window.addEventListener('focus', this.refreshOnFocus, {once: true});
        this.tempTemplates = [];
        this.templates.forEach(item => {
            this.tempTemplates.push(item.value);
        });
        this.sendInBlueApiService.newSmtpTemplate();
    }

    setDisabledState(disabled: boolean): void { this.disabled = disabled; }

    ngOnDestroy(): void {
        this.request?.unsubscribe();
        window.removeEventListener('focus', this.refreshOnFocus);
    }

    private load(): void {
        this.request?.unsubscribe();
        this.templates = [];
        this.template = undefined;
        this.loadError = false;
        this.loading = false;
        if (!this.tenant) { return; }
        this.loading = true;
        this.request = this.configuratorSendInBlueService.getAllTransactionalEmails1(this.tenant).subscribe({
            next: data => {
                this.templates = (data || []).map(t => ({value: t.key, label: t.value}));
                this.setValue();
                this.loading = false;
            }, error: () => { this.loadError = true; this.loading = false; }
        });
    }
}
